<div class="landing-container">
  <!-- Navigation -->
  <nav class="navbar">
    <div class="navbar-inner">
      <div class="logo">
        <h1>{{ 'pages.landing.navbar.logo' | translate }}</h1>
      </div>
      <div class="navbar-actions">
        @if ((isAuthenticated$ | async)) {
          <span class="login-status">{{ 'pages.landing.navbar.logged_in' | translate }}</span>
          <button class="btn btn-outline btn-sm btn-inline" (click)="logout()">
            {{ 'pages.landing.navbar.logout' | translate }}
          </button>
        } @else {
          <a routerLink="/login" class="btn btn-primary btn-sm btn-inline">
            {{ 'pages.landing.navbar.login' | translate }}
          </a>
        }
      </div>
    </div>
  </nav>

  <!-- Hero Section -->
  <section class="hero">
    <div class="hero-content">
      <h1>{{ 'pages.landing.hero.title' | translate }}</h1>
      <p class="hero-subtitle">
        {{ 'pages.landing.hero.subtitle' | translate }}
      </p>
      <div class="hero-buttons">
        <a routerLink="/login" class="btn btn-primary btn-lg">
          {{ 'pages.landing.hero.cta_primary' | translate }}
        </a>
        <a href="#features" class="btn btn-outline">
          {{ 'pages.landing.hero.cta_secondary' | translate }}
        </a>
      </div>
    </div>
  </section>

  <!-- Features Section -->
  <section id="features" class="features">
    <h2 class="section-title">{{ 'pages.landing.features.title' | translate }}</h2>

    <div class="features-grid">
      <!-- Feature: User Management -->
      <div class="feature-card">
        <div class="feature-icon">👥</div>
        <h3>{{ 'pages.landing.features.users.title' | translate }}</h3>
        <p>{{ 'pages.landing.features.users.description' | translate }}</p>
      </div>

      <!-- Feature: Group Sports -->
      <div class="feature-card">
        <div class="feature-icon">⚽</div>
        <h3>{{ 'pages.landing.features.teams_group.title' | translate }}</h3>
        <p>{{ 'pages.landing.features.teams_group.description' | translate }}</p>
      </div>

      <!-- Feature: Individual Sports -->
      <div class="feature-card">
        <div class="feature-icon">🏃</div>
        <h3>{{ 'pages.landing.features.teams_individual.title' | translate }}</h3>
        <p>{{ 'pages.landing.features.teams_individual.description' | translate }}</p>
      </div>

      <!-- Feature: Attendance -->
      <div class="feature-card">
        <div class="feature-icon">✅</div>
        <h3>{{ 'pages.landing.features.attendance.title' | translate }}</h3>
        <p>{{ 'pages.landing.features.attendance.description' | translate }}</p>
      </div>

      <!-- Feature: Payments -->
      <div class="feature-card">
        <div class="feature-icon">💰</div>
        <h3>{{ 'pages.landing.features.payments.title' | translate }}</h3>
        <p>{{ 'pages.landing.features.payments.description' | translate }}</p>
      </div>

      <!-- Feature: Recruitment -->
      <div class="feature-card">
        <div class="feature-icon">📝</div>
        <h3>{{ 'pages.landing.features.recruitment.title' | translate }}</h3>
        <p>{{ 'pages.landing.features.recruitment.description' | translate }}</p>
      </div>

      <!-- Feature: Injuries -->
      <div class="feature-card">
        <div class="feature-icon">🏥</div>
        <h3>{{ 'pages.landing.features.injuries.title' | translate }}</h3>
        <p>{{ 'pages.landing.features.injuries.description' | translate }}</p>
      </div>

      <!-- Feature: Documents -->
      <div class="feature-card">
        <div class="feature-icon">📄</div>
        <h3>{{ 'pages.landing.features.documents.title' | translate }}</h3>
        <p>{{ 'pages.landing.features.documents.description' | translate }}</p>
      </div>
    </div>
  </section>

  <!-- Pricing Section — HIDDEN (ceny nie są jeszcze ustalone) -->
  <!--
  <section class="pricing">
    ...
  </section>
  -->

  <!-- CTA Section -->
  <section class="cta">
    <h2>{{ 'pages.landing.cta.title' | translate }}</h2>
    <p>{{ 'pages.landing.cta.subtitle' | translate }}</p>
    <a routerLink="/login" class="btn btn-primary btn-lg">
      {{ 'pages.landing.cta.button' | translate }}
    </a>
  </section>

  <!-- Footer -->
  <footer class="footer">
    <div class="footer-content">
      <p>{{ 'pages.landing.footer.copyright' | translate }}</p>
      <p class="footer-version">{{ 'common.app_version' | translate: { version: appVersion } }}</p>
      <div class="footer-links">
        <a href="#privacy">{{ 'pages.landing.footer.privacy' | translate }}</a>
        <a href="#terms">{{ 'pages.landing.footer.terms' | translate }}</a>
        <a href="#contact">{{ 'pages.landing.footer.contact' | translate }}</a>
      </div>
    </div>
  </footer>
</div>
